import { render, staticRenderFns } from "./ProfileMedicalHistory.vue?vue&type=template&id=ed210690&"
import script from "./ProfileMedicalHistory.vue?vue&type=script&lang=js&"
export * from "./ProfileMedicalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports